import { Component } from '@angular/core';

@Component({
  selector: 'app-dag-section',
  templateUrl: './dag-section.component.html'
})
export class DagSectionComponent {

}
